<template>
  <div>
    <Header />
    <Banner />
    <AmsHandwareProductsPage />
    <Footer />
  </div>
</template>
<script>
import Banner from '../components/Banner.vue'
import Footer from '../components/Footer.vue'
import AmsHandwareProductsPage from '../components/AmsHandwareProductsPage.vue'
import Header from '@/components/Header.vue'

export default {
  name: 'AmsHandwareProducts',
  components: {
    Banner,
    Footer,
    AmsHandwareProductsPage,
    Header
  }
}
</script>